import { useEffect } from 'react';
import { useFetchTags } from '../components/documentation/salesforce-documentation-card/annotations/tags/useFetchTags';
import { useDefaultEnvId } from '../components/pages/environments/default-env-context/DefaultEnvContext';

/**
 * Add an effect to any call that should be triggered whenever crmOrgId changes
 */

export const useFetchUponCrmOrgChange = () => {
  const crmOrgId = useDefaultEnvId();
  const fetchTags = useFetchTags();

  useEffect(() => {
    if (crmOrgId) {
      fetchTags(crmOrgId);
    }
  }, [crmOrgId, fetchTags]);
};
